import { Pipe, PipeTransform } from '@angular/core';

import { OPERATING_MODE_ICON } from '../icons';

@Pipe({
  name: 'iconOperatingMode',
})
export class IconOperatingModePipe implements PipeTransform {
  transform(value: string, ...args: any[]): string {
    const defaultIcon = OPERATING_MODE_ICON['default'];

    if (value && OPERATING_MODE_ICON[value]) {
      const dash = args && args[0] === 'dash' ? '-dash' : '';

      return OPERATING_MODE_ICON[value] + dash || defaultIcon;
    }

    return defaultIcon;
  }
}
